// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"ad724be9","881":"c3abc05b","988":"886fcfe9"}[chunkId] + ".chunk.js";
};